import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface SetCandidateLanguageResponse extends BackendResponse {}
export interface SetCandidateLanguageParameters extends NextApiParams {
  idCandidate: number;
  idLanguage: number;
}

export const setCandidateLanguage = withNextApi<
  SetCandidateLanguageResponse,
  SetCandidateLanguageParameters
>("/cvp/CvpSetCandidateLanguage");
